import angular from 'angular';
import uiRouter from 'angular-ui-router';
import episodesComponent from './episodes.component';

let episodesModule = angular.module('episodes', [
  uiRouter
])

.component('episodes', episodesComponent);

export default episodesModule;



// WEBPACK FOOTER //
// ./client/app/common/admin/episodes/episodes.js